import { useEffect } from "react";
import { useAppDispatch } from "../ReduxToolkit/Hooks";
import { errorMessageUtil } from "../utils/serviceUtils/errorMessage";
import { closeModal } from "../ReduxToolkit/Slice/UserProfileDetailsModalSlice";
import { useNavigate } from "react-router-dom"; // if using react-router
import { loginPath } from "../utils/Constant";

interface AlertConfig {
  textMessage:
    | string
    | { status?: number; message?: string }
    | null
    | undefined;
  clearActions: Array<() => void>;
  alertFunc: (params: { text: string; onConfirm: () => void }) => void;
  message?: string;
}

export const useAlerts = (errorsConfig: AlertConfig[]) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!errorsConfig || errorsConfig.length === 0) return;

    errorsConfig.forEach(
      ({ textMessage, clearActions, alertFunc, message }) => {
        if (!textMessage) return;

        const isSessionTimeout =
          typeof textMessage === "object" &&
          textMessage?.status === 403 &&
          textMessage?.message === "Session Timeout!";

        if (isSessionTimeout) {
          localStorage.clear();
          navigate(loginPath, { replace: true });
        }

        const alertText =
          typeof textMessage === "object"
            ? errorMessageUtil(
                textMessage.message || message || "Something went wrong"
              )
            : errorMessageUtil(textMessage);

        alertFunc({
          text: alertText,
          onConfirm: () => {
            clearActions?.forEach((action) => dispatch(action() as any));
            dispatch(closeModal());
          },
        });
      }
    );
  }, [JSON.stringify(errorsConfig)]); // 🔁 Only re-run if actual values change
};
